import { FulfilledActionFromAsyncThunk, AnyAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
import { EntityTypes } from 'constants/entities';
import { updateState, IUpdateState, restoreState } from 'core/actions/product/state';
import { createRequest } from 'core/services/admin';
import { attemptRequest, searchRequest } from 'core/services/product';
import { registerAttempt } from 'core/slices/register';
import { updateToken } from 'core/slices/session';
import { IAttempt, IAttemptAction, ITokenAction } from 'types/action/player';
import { ISessionAttempt } from 'types/domain/session';
import { IAuthResponse } from 'types/session/auth';

export function cases(builder) {
  builder
    .addCase(updateState, (state, action) => {
      const { type, id }: IUpdateState = action.payload;
      if (state[type] === undefined || id === undefined) return state;
      state[type] = id;
    })
    .addCase(restoreState, (state, action) => {
      action.payload.forEach(update => {
        const { type, id }: IUpdateState = update;
        if (state[type] === undefined) return state;
        state[type] = id ? id : null;
      });
    })
    .addCase(updateToken, (state, action) => {
      const { token }: ITokenAction = action.payload;
      if (state[EntityTypes.TOKEN] === undefined || token === undefined) return state;
      state[EntityTypes.TOKEN] = token;
    })
    .addCase(createRequest.fulfilled, (state, action: FulfilledActionFromAsyncThunk<AnyAsyncThunk>) => {
      const { type } = action.meta.arg;
      const { id, offlineId } = action.payload;
      if (state[type] === undefined) return state;
      state[type] = state[type] === offlineId ? id : state[type];
    })
    .addCase(registerAttempt, (state, action: FulfilledActionFromAsyncThunk<AnyAsyncThunk>) => {
      const { sessionAttemptId } = action.payload as IAttempt;
      state[EntityTypes.SESSION_ATTEMPT] = sessionAttemptId;
    })
    .addCase(attemptRequest.pending, (state, action: FulfilledActionFromAsyncThunk<AnyAsyncThunk>) => {
      const { offlineId } = action.meta.arg as IAttempt;
      state[EntityTypes.SESSION_ATTEMPT] = offlineId;
    })
    .addCase(searchRequest.fulfilled, (state, action: FulfilledActionFromAsyncThunk<AnyAsyncThunk>) => {
      const { searchResponse } = action.payload as IAuthResponse;
      state[EntityTypes.SEARCH] = searchResponse ? searchResponse.searchId : null;
    })
    .addCase(attemptRequest.fulfilled, (state, action: FulfilledActionFromAsyncThunk<AnyAsyncThunk>) => {
      const { offlineId } = action.meta.arg as IAttemptAction;
      const { id } = action.payload as ISessionAttempt;

      if (state[EntityTypes.SESSION_ATTEMPT] === undefined) return state;
      if (state[EntityTypes.SESSION_ATTEMPT] === offlineId) state[EntityTypes.SESSION_ATTEMPT] = id;
    });
}
